import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContactMatrix } from '../../../../core/models/contact-matrix.model';
import { JOB_LABELS } from '../../../../shared/services/job_labels.service';
import { forEach, keys, reduce } from 'lodash-es';
import { AccountAttributesEnum } from 'src/app/shared/enums/account-attributes.enum';
import { UserService } from 'src/app/core/services/user.service';

@Component({
    selector: 'app-contact-matrix-panel',
    templateUrl: './contact-matrix-panel.component.html',
    styleUrls: ['./contact-matrix-panel.component.scss'],
    standalone: false
})
export class ContactMatrixPanelComponent implements OnInit {

    @Input() contactMatrix;
    @Input() listDetail;

    @Output() contactClick: EventEmitter<void> = new EventEmitter();
    jobLevelLabels = JOB_LABELS.levels;
    jobLevelKeys = keys(this.jobLevelLabels);
    jobDepartmentLabels = JOB_LABELS.departments;
    jobDepartmentKeys = keys(this.jobDepartmentLabels);
    verifiedContacts: ContactMatrix[] = [new ContactMatrix(), new ContactMatrix()];
    totalContactCount = 0;
    totalHumanContactCount = 0;
    totalPendingContactCount = 0;
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;

    constructor(private readonly userService: UserService) { }

    ngOnInit(): void {
        this.verifiedContacts[0].Type = 'Contact';
        this.verifiedContacts[1].Type = 'Contact';
        this.verifiedContacts[0].ListId = this.listDetail.id;
        this.verifiedContacts[1].ListId = this.listDetail.id;
        this.jobLevelKeys.forEach((level) => {
            this.verifiedContacts[0].Contacts[level] = {};
            this.verifiedContacts[1].Contacts[level] = {};
        });
        this.verifiedContacts[0].IsHumanVerified = true;
        this.verifiedContacts[1].IsHumanVerified = false;
        if (this.contactMatrix) {
            this.setContactMatrix(0, this.contactMatrix.hvEvContactMatrix);
            this.setContactMatrix(1, this.contactMatrix.hvEvMvContactMatrix);
        }
    }

    setContactMatrix(verifiedType: number, contactMatrixResponse: any) {
        const tmpJobLevelCounts = reduce(this.jobLevelKeys, function (acc, item) {
            acc[item] = 0;
            return acc;
        }, {});
        const tmpJobDepartmentCounts = reduce(this.jobDepartmentKeys, function (acc, item) {
            acc[item] = 0;
            return acc;
        }, {});
        let count = 0;
        let totalCount = 0;
        forEach(contactMatrixResponse, (jobDepartment, jobLevel) => {
            if (jobLevel !== 'other') {
                forEach(contactMatrixResponse[jobLevel], (tempLevel, selectedDepartment) => {
                    count = contactMatrixResponse[jobLevel][selectedDepartment].count;
                    totalCount = totalCount + count;
                    tmpJobLevelCounts[jobLevel] = tmpJobLevelCounts[jobLevel] + count;
                    tmpJobDepartmentCounts[selectedDepartment] = tmpJobDepartmentCounts[selectedDepartment] + count;

                    if (!(jobLevel in this.verifiedContacts[verifiedType].LevelTotals)) {
                        this.verifiedContacts[verifiedType].LevelTotals[jobLevel] = 0;
                    }
                    this.verifiedContacts[verifiedType].LevelTotals[jobLevel] += count;

                    if (!(selectedDepartment in this.verifiedContacts[verifiedType].DepartmentTotals)) {
                        this.verifiedContacts[verifiedType].DepartmentTotals[selectedDepartment] = 0;
                    }
                    this.verifiedContacts[verifiedType].DepartmentTotals[selectedDepartment] += count;

                    if (!(jobLevel in this.verifiedContacts[verifiedType].Contacts)) {
                        this.verifiedContacts[verifiedType].Contacts[jobLevel] = {};
                    }
                    if (!(selectedDepartment in this.verifiedContacts[verifiedType].Contacts[jobLevel])) {
                        this.verifiedContacts[verifiedType].Contacts[jobLevel][selectedDepartment] = 0;
                    }
                    this.verifiedContacts[verifiedType].Contacts[jobLevel][selectedDepartment] += count;
                });
            }
        });

        this.totalContactCount = totalCount;
        if (verifiedType === 0) {
            this.totalHumanContactCount = totalCount;
            this.verifiedContacts[0].TotalContacts = this.totalHumanContactCount;
        } else {
            this.totalPendingContactCount = totalCount;
            this.verifiedContacts[1].TotalContacts = this.totalPendingContactCount;
        }
    }

    onContactClick() {
        this.contactClick.emit();
    }
}
